import React, { useEffect, useState } from "react";
import "css/components.css";
import World from "assets/world.png";
import AnimatedCirclesComponent from "./CircleAnimation";
import { BsStars } from "react-icons/bs";

const chatMessages = [
  "Which grain shows the largest commercial/non-commercial spread?",
  "How are commercials positioned in corn futures?",
  "What's the current wheat speculators' net position?",
  "Show me soybean positioning trends this month",
  "Compare managed money positions across grains",
];

const FeatureOne = () => {
  return (
    <div className="feature-box">
      <div className="feature-box-title">
        <h3
          className="title-cool"
          style={{
            fontSize: "40px",
            letterSpacing: "0.02em",
            fontWeight: "600",
            textAlign: "start",
          }}
        >
          Decodes Complexity
        </h3>
        <p>
          We transform dense COT and WASDE reports into sharp, high-contrast
          visuals.
        </p>
      </div>

      {/* Progress bars container */}
      <div
        style={{
          margin: "24px 0px",
          display: "flex",
          flexDirection: "column",
          gap: "24px",
          width: "100%",
        }}
      >
        {/* First progress bar - 100% */}
        <div
          style={{
            position: "relative",
            height: "4px",
            backgroundColor: "#3c644b77",
            borderRadius: "32px",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "100%",
              backgroundColor: "white",
              borderRadius: "32px",
            }}
          />
        </div>

        {/* Second progress bar - 75% */}
        <div
          style={{
            position: "relative",
            height: "4px",
            backgroundColor: "#3c644b77",
            borderRadius: "32px",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "75%",
              backgroundColor: "white",
              borderRadius: "32px",
            }}
          />
        </div>

        {/* Third progress bar - 60% */}
        <div
          style={{
            position: "relative",
            height: "4px",
            backgroundColor: "#3c644b77",
            borderRadius: "32px",
            width: "100%",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: "60%",
              backgroundColor: "white",
              borderRadius: "32px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

const FeatureTwo = () => {
  return (
    <div
      className="feature-box feature-box-s"
      style={{
        padding: "24px 24px 0px 24px",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      <div className="feature-box-title">
        <h3
          className="title-cool"
          style={{
            fontSize: "40px",
            letterSpacing: "0.02em",
            fontWeight: "600",
            textAlign: "start",
          }}
        >
          Built for Action
        </h3>
        <p>
          We provide the clarity needed to move before market windows slam shut.
        </p>
      </div>

      <AnimatedCirclesComponent />
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const FeatureThree = () => {
  return (
    <div
      className="feature-box feature-box-s"
      style={{ padding: "24px 24px 0px 24px", alignItems: "center" }}
    >
      <div className="feature-box-title">
        <h3
          className="title-cool"
          style={{
            fontSize: "40px",
            letterSpacing: "0.02em",
            fontWeight: "600",
            textAlign: "start",
          }}
        >
          Track Position Changes in Real-Time
        </h3>
        <p>
          Monitor how funds, commercial entities, and retail traders adjust
          their positions as markets evolve
        </p>
      </div>

      <img src={World} width={"100%"} alt="world" />
    </div>
  );
};

const AnimatedChatItem = ({ message, style }) => (
  <div
    style={{
      display: "flex",
      gap: "12px",
      alignItems: "center",
      position: "absolute",
      left: 0,
      right: 0,
      transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
      ...style,
    }}
  >
    <div
      style={{
        backgroundColor: "#184e24",
        borderRadius: "100%",
        padding: "12px",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      <BsStars size={"20px"} />
    </div>
    <div
      style={{
        width: "calc(100% - 60px)",
        border: "2px solid #3ba54a",
        padding: "12px 18px",
        backgroundColor: "#21632d",
        borderRadius: "26px",
      }}
    >
      {message}
    </div>
  </div>
);

const FeatureFour = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % chatMessages.length);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  const getPosition = (index) => {
    const diff =
      (index - currentIndex + chatMessages.length) % chatMessages.length;

    if (diff === 0) {
      // First visible item (top)
      return { top: 20, opacity: 0.7 };
    } else if (diff === 1) {
      // Second visible item (bottom)
      return { top: 80, opacity: 0.4 };
    } else if (diff === chatMessages.length - 1) {
      // Item that just scrolled out (above viewport)
      return { top: -40, opacity: 0 };
    } else {
      // Items waiting below
      return { top: 140, opacity: 0 };
    }
  };

  return (
    <div className="feature-box" style={{ flex: 1 }}>
      <div className="feature-box-title">
        <h3
          className="title-cool"
          style={{
            fontSize: "40px",
            letterSpacing: "0.02em",
            fontWeight: "600",
            textAlign: "start",
          }}
        >
          Filters Noise
        </h3>
        <p>
          Our AI pinpoints market shifts that impact your specific storage,
          hedging, and pricing windows.
        </p>
      </div>

      <div
        style={{
          position: "relative",
          height: "150px",
          width: "100%",
          overflow: "hidden",
          maskImage:
            "linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)",
          WebkitMaskImage:
            "linear-gradient(to bottom, transparent 0%, black 20%, black 80%, transparent 100%)",
        }}
      >
        {chatMessages.map((message, index) => {
          const pos = getPosition(index);
          return (
            <AnimatedChatItem
              key={index}
              message={message}
              style={{
                top: pos.top,
                opacity: pos.opacity,
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default function HomeFeatures() {
  return (
    <div id="features" className="bg-circle-center">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          padding: "180px 32px",
          gap: "16px",
        }}
      >
        <div
          style={{
            background: "linear-gradient(180deg, #051C0E 0%, #103A1B 100%)",
            borderRadius: "32px",
            border: "1px solid white",
            padding: "8px 24px",
            fontSize: "14px",
            fontWeight: "500",
            color: "white",
            width: "fit-content",
            letterSpacing: "0.1em",
          }}
        >
          WHAT WE DO
        </div>
        <h1 className="title-cool" style={{ fontSize: "2.5rem" }}>
          Everything You Need to Stay Ahead
        </h1>

        {/* Features Grid */}
        <div className="feature-grid">
          {/* First row - 75% | 25% */}
          <div className="feature-row">
            <FeatureOne />
            <FeatureTwo />
          </div>

          {/* Second row - 25% | 75% */}
          <div className="feature-row">
            {/* <FeatureThree /> */}
            <FeatureFour />
          </div>
        </div>
      </div>
    </div>
  );
}
